import { Box, CircularProgress } from '@mui/material'
import type { AgGridReactProps } from 'ag-grid-react'
import { initAgGrid } from '@/core/agGrid/initAgGrid'
import React, { useEffect, useState } from 'react'

type AgGridComponent = React.ComponentType<AgGridReactProps>

export function OtwAgGridReact<TData = unknown>(props: AgGridReactProps<TData>) {
  const [AgGridReact, setAgGridReact] = useState<AgGridComponent | null>(null)

  useEffect(() => {
    let cancelled = false
    void initAgGrid()
      .then(() => import('ag-grid-react'))
      .then(module => {
        if (!cancelled) {
          setAgGridReact(() => module.AgGridReact as AgGridComponent)
        }
      })
    return () => {
      cancelled = true
    }
  }, [])

  if (!AgGridReact) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}>
        <CircularProgress size={32} />
      </Box>
    )
  }

  return <AgGridReact {...props} />
}
